import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {Observable} from "rxjs";
import {SchuleDTO} from "../../../models/schule/SchuleDTO";
import {HttpHeaderService} from "../../utils/http/http-header.service";
import {SchuleMinimalDTO} from "../../../models/schule/SchuleMinimalDTO";
import {SchoolLevel} from "../../../models/schule/SchoolLevel";

@Injectable({
  providedIn: 'root'
})
export class SchuleService {

  configUrl = 'api/schule';

  constructor(
    private http: HttpClient,
    private headerService: HttpHeaderService
  ) {}

  getSchulen(filterArchived: boolean): Observable<Array<SchuleDTO>> {
    return this.http.get<Array<SchuleDTO>>(
      this.configUrl+'/bulk?filterArchived='+filterArchived,
      { headers: this.headerService.getAuthHeaderApplicationJson() }
    );
  }

  getSchulenForAntrag(): Observable<Array<SchuleDTO>> {
    return this.http.get<Array<SchuleDTO>>(this.configUrl+'/bulk-for-antrag?filterArchived=true',
      { headers: this.headerService.getAuthHeaderApplicationJson() });
  }

  getSchuleListBulk(): Observable<Array<SchuleDTO>> {
    return this.http.get<Array<SchuleDTO>>(
      this.configUrl+'/bulk',
      { headers: this.headerService.getAuthHeaderApplicationJson() }
    );
  }

  getSchulenForRegistration(): Observable<Array<SchuleMinimalDTO>> {
    return this.http.get<Array<SchuleMinimalDTO>>(this.configUrl+'/bulk-minimal');
  }

  getSchoolLevelsForSchule(id: string): Observable<SchoolLevel[]>{
    return this.http.get<SchoolLevel[]>(this.configUrl+'/'+id+'/allowed-school-levels', { headers: this.headerService.getAuthHeaderApplicationJson() });
  }

}
